import React from '../../vendor/react';
import { useState } from '../../vendor/react';
import { LockKeyhole, Mail, UserPlus, UserRound } from '../../vendor/lucide-react';
import { Link, navigate } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../features/auth/auth-store';
import { isEmail, isStrongPassword } from '../../features/auth/validation';

export function RegisterPage() {
  const auth = useAuth();
  const [error, setError] = useState('');
  const submit = async (event: SubmitEvent) => {
    event.preventDefault();
    setError('');
    const data = new FormData(event.currentTarget as HTMLFormElement);
    const firstName = String(data.get('firstName') ?? '').trim();
    const lastName = String(data.get('lastName') ?? '').trim();
    const email = String(data.get('email') ?? '');
    const password = String(data.get('password') ?? '');
    const terms = data.get('terms');
    if (!firstName || !lastName) return setError('Escribe tu nombre y apellidos.');
    if (!isEmail(email)) return setError('Escribe un correo válido.');
    if (!isStrongPassword(password)) return setError('Usa mínimo 8 caracteres, mayúscula, minúscula y número.');
    if (!terms) return setError('Debes aceptar los términos para crear la cuenta.');
    try {
      const result = await auth.actions.signUp({ firstName, lastName, email, password });
      if (!result.session) throw new Error('No se pudo iniciar la sesión después del registro. Revisa que Confirm email esté desactivado en Supabase.');
      navigate('/onboarding', { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'No se pudo crear la cuenta.');
    }
  };

  return (
    <AuthLayout eyebrow="Nueva cuenta" title="Prepara tu espacio de negocio" description="Crea tu cuenta con correo y contraseña. Entrarás de inmediato para configurar tu negocio y activar la prueba gratuita.">
      {error && <AuthNotice tone="error">{error}</AuthNotice>}
      <form className="auth-form" onSubmit={submit}>
        <div className="auth-form__grid">
          <label className="auth-field"><span>Nombre</span><div><UserRound size={18} /><input name="firstName" autoComplete="given-name" placeholder="Nombre" required /></div></label>
          <label className="auth-field"><span>Apellidos</span><div><UserRound size={18} /><input name="lastName" autoComplete="family-name" placeholder="Apellidos" required /></div></label>
        </div>
        <label className="auth-field"><span>Correo electrónico</span><div><Mail size={18} /><input name="email" type="email" autoComplete="email" placeholder="tu@negocio.com" required /></div></label>
        <label className="auth-field"><span>Contraseña</span><div><LockKeyhole size={18} /><input name="password" type="password" autoComplete="new-password" placeholder="Mínimo 8 caracteres" required /></div><small>Incluye mayúscula, minúscula y número.</small></label>
        <label className="auth-check"><input type="checkbox" name="terms" /><span>Acepto los términos de uso y el aviso de privacidad configurables.</span></label>
        <Button type="submit" size="lg" className="full-width" icon={<UserPlus size={18} />}>Crear mi cuenta</Button>
      </form>
      <p className="auth-card__footer">¿Ya tienes cuenta? <Link to="/ingresar">Iniciar sesión</Link></p>
    </AuthLayout>
  );
}
